module.exports = __webpack_public_path__ + "static/003-82f57fea31f52c8e2128e8b080980492.png";